import { render, staticRenderFns } from "./ImageButton.html?vue&type=template&id=5abd7253&scoped=true&"
import script from "./ImageButton.js?vue&type=script&lang=js&"
export * from "./ImageButton.js?vue&type=script&lang=js&"
import style0 from "./ImageButton.scss?vue&type=style&index=0&id=5abd7253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd7253",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VRow})
